import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  code: {
    marginRight: Spacing.M,
  },
})

interface Props extends ViewProps {}

const GeneralErrorScreen = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View>
        <Text level={1} style={styles.code}>
          <Trans>Oops! Something went wrong</Trans>
        </Text>
      </View>
      <Text>
        <Trans>Please contact our support team</Trans>
      </Text>
    </View>
  )
}

export default GeneralErrorScreen
